export enum QUERY_NAME {
  userRequest = 'userRequest',
  userRequests = 'userRequests',
  exportUserRequests = 'exportUserRequests',
  companyNames = 'companyNames',
}
